import { createContext } from "react";

/** The breadcrumb title setter function. */
export interface BreadcrumbTitleSetter {
  
  /** Sets the current breadcrumb title. */
  (title: string | null): void;
}

/** Breadcrumb data. */
export interface BreadcrumbData {
  
  /** The breadcrumb title. */
  readonly title: string;

  /** The breadcrumb path. */
  readonly path: string;
}

/** A breadcrumb data entry. */
export interface RegisteredBreadcrumbData extends BreadcrumbData {
  
  /** The ID of the breadcrumb parent entry. */
  readonly parentIndex: number | null;
}

/** The breadcrumb context data. */
export interface BreadcrumbContextData {
  
  /** The current breadcrumb nodes. */
  nodes: ReadonlyArray<RegisteredBreadcrumbData>;

  /** The current title override. */
  titleOverride: { pathname: string; title: string } | null;

  /** Sets the current items. */
  setItems(items: ReadonlyArray<RegisteredBreadcrumbData>): () => void;

  /** Sets the current title. */
  setTitle: BreadcrumbTitleSetter;
}

/** The breadcrumb context. */
export const BreadcrumbContext = createContext<BreadcrumbContextData>({
  nodes: [],
  titleOverride: null,
  setItems: () => (): void => {
    /* Do nothing */
  },
  setTitle: () => {
    /* Do nothing */
  },
});
